function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { Constants as CONSTANTS } from './constants.class';
import { hitEventTms } from 'integration-web-core--socle/js/assets/commons/_tms';
var Tracking = /*#__PURE__*/function () {
  function Tracking(options) {
    _classCallCheck(this, Tracking);
    this.options = options;
    this.trackingConfigObject = {};
    try {
      if (this.options.event === undefined || this.options.event === null) throw new Error('Paramètre Event est obligatoire!');
      this.eventTarget = this.options.event.target;
      this.track();
    } catch (err) {
      console.error('Error : ', err);
    }
  }
  return _createClass(Tracking, [{
    key: "track",
    value: function track() {
      _initTrackingConfig.call(this);
      hitEventTms(this.eventTarget, 'gaEvent', JSON.stringify(this.trackingConfigObject));
    }
  }]);
}();
export default Tracking;
function _initTrackingConfig() {
  this.trackingConfigObject.action = "".concat(CONSTANTS.TRACKING_INFOS.UNIVERSE, "/").concat(CONSTANTS.TRACKING_INFOS.SUB_UNIVERSE, "/").concat(CONSTANTS.TRACKING_INFOS.FAMILY, "/").concat(CONSTANTS.TRACKING_INFOS.SUB_FAMILY);
  if (this.options.type === 'filter' || this.options.type === 'pedagogicalFilters') {
    if (this.eventTarget.dataset.type && this.eventTarget.dataset.type === 'toggle') {
      this.trackingConfigObject.label = "".concat(this.eventTarget.dataset.type, " - ").concat(this.eventTarget.dataset.category);
    } else {
      this.trackingConfigObject.label = this.eventTarget.dataset.category;
    }
    this.trackingConfigObject.parameters = {};
    this.trackingConfigObject.parameters['dimension20'] = this.eventTarget.dataset.filterValue ? this.eventTarget.dataset.filterValue : this.eventTarget.value;
    this.trackingConfigObject.categorie = this.eventTarget.checked ? CONSTANTS.TRACKING_INFOS.CATEGORY_CHECKED : CONSTANTS.TRACKING_INFOS.CATEGORY_UNCHECKED;
  }
  if (this.options.type === 'sorting') {
    this.trackingConfigObject.label = this.eventTarget.options[this.eventTarget.selectedIndex].text;
    this.trackingConfigObject.categorie = "".concat(CONSTANTS.TRACKING_INFOS.SORTING);
  }
  if (this.options.type === 'range') {
    var targetCategory = this.eventTarget.dataset.category;
    var inputsRange = document.querySelectorAll("input[data-category=".concat(targetCategory, "]"));
    this.trackingConfigObject.parameters = {};
    this.trackingConfigObject.parameters['dimension20'] = "".concat(inputsRange[0].value, " - ").concat(inputsRange[1].value);
    this.trackingConfigObject.label = targetCategory;
  }
}